import { PerfCommonData, EXTER_PREF, Options, REPORT_TYPE } from "../index.interface"
import { reportFMP } from "../util/fmp"
import getTTI from "../util/tti"
import webVitals from "../util/webVitals"
import { isAPISupport, getPerfTime } from "../util/perf"

const _win = window
const PERF_KEY = { fmp: "useFMP", fcp: "useFCP", tti: "useTTI", lcp: "useLCP", inp: "useINP" }

/**
 * 默认性能数据轮询间隔时间
 *
 * 性能指标未采集完成时，每隔该时间轮询一次。
 * 可通过 `options.perfInterval` 覆盖，默认 600ms。
 */
const INTERVAL_TIME = 600

export const getCommonData = (): PerfCommonData => {
  // @ts-ignore
  const sr = `${screen.width}x${screen.height}`
  const dpr = (_win.devicePixelRatio || 1).toFixed(2)
  const common = {
    sr,
    dpr,
  }
  return common
}

/**
 * 工厂函数：为每个 Tracer 实例创建独立的性能数据采集器，
 * 避免多实例共享 _perf / timer 模块级变量导致数据污染。
 *
 * 返回该实例专属的 reportPerf 和 reportCLS 方法。
 */
export function createPerfWatcher(options: Options) {
  const _perf: EXTER_PREF = { fmp: -9999, fcp: -9999, tti: -9999, lcp: -9999, inp: -9999 }

  // 轮询间隔：优先使用调用方传入的 perfInterval（必须为正数），
  // 未传或非法值（0/负数/NaN）时回退到默认 600ms，避免 setTimeout(0) 高频空转
  const intervalTime =
    typeof options.perfInterval === "number" && options.perfInterval > 0
      ? options.perfInterval
      : INTERVAL_TIME

  let timer: ReturnType<typeof setTimeout> | null = null

  function isFinishToReportPerf() {
    return Object.keys(_perf).length
      ? Object.keys(_perf).every((item) => {
          return options[PERF_KEY[item]] ? !!(_perf[item] >= 0 || _perf[item] === -1) : true
        })
      : true
  }

  // 启动各项指标采集
  if (options.useFCP) {
    webVitals
      .getFCP()
      .then((fcp) => {
        fcp && (_perf.fcp = fcp)
      })
      .catch(() => {
        _perf.fcp = -1
      })
  }
  if (options.useFMP) {
    reportFMP()
      .then((res) => {
        _perf.fmp = res
      })
      .catch(() => {
        delete _perf.fmp
      })
  }
  if (options.useTTI) {
    getTTI()
      .then((tti) => {
        _perf.tti = !tti ? -1 : tti
      })
      .catch(() => {
        delete _perf.tti
      })
  }
  if (options.useLCP) {
    webVitals
      .getLCP()
      .then((lcp) => {
        lcp && (_perf.lcp = lcp)
      })
      .catch(() => {
        _perf.lcp = -1
      })
  }
  if (options.useINP) {
    webVitals
      .getINP()
      .then((inp) => {
        inp && (_perf.inp = inp)
      })
      .catch(() => {
        _perf.inp = -1
      })
  }

  function reportPerf(cb: Function) {
    if (isAPISupport()) {
      if (isFinishToReportPerf()) {
        console.log("[Perf] isFinishToReportPerf >>>>>>")
        cb({
          type: REPORT_TYPE.Perf,
          data: {
            ...getPerfTime(_perf),
            ..._perf,
          },
        })
      } else {
        timer = setTimeout(() => {
          timer = null
          reportPerf(cb)
        }, intervalTime)
      }
    }
  }

  function reportCLS(cb: Function) {
    webVitals.getCLS((value) => {
      console.log("[Perf] getCLS >>>>>>", value)
      value &&
        cb({
          type: REPORT_TYPE.Perf,
          data: {
            cls: value,
          },
        })
    })
  }

  return { reportPerf, reportCLS }
}
